<template>
  <button :class="buttonCls" type="button" :disabled="!!this.disabled" @click="trigger">
    <i :class="iconCls" v-if="!!iconCode"></i>
    <span v-if="hasText"><slot></slot></span>
  </button>
<!-- <scripton> -->
</template>
<script>
const prefix = "h-btn"
const Props = {
  size: ["l", "s", "xs"],
}
export default {
  name: "hButton",
  props: {
    color: {type: String,default:'blue'},
    textColor: String,
    icon: String,
    loading: Boolean,
    circle: {type: Boolean,default:true},
    block: Boolean,
    noBorder: {type: Boolean,default:true},
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      validator(value) {
        return Props.size.indexOf(value) != -1
      },
    },
    stop: {
      type: Boolean,
      default: false,
    },
    preventDefault: {
      type: Boolean,
      default: false,
    },
    text: Boolean,
    iconCircle: Boolean,
    transparent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  mounted(){
    // debugger
      if(this.circle){
        this.$nextTick(()=>{
           this.$el.style.borderRadius = this.$el.offsetHeight + 'px'
        })
      }
  },
  methods: {
    trigger(event) {
      if (this.stop) {
        event.stopPropagation()
      }
      if (this.preventDefault) {
        event.preventDefault()
      }
      this.$emit("click", event)
    },
  },
  computed: {
    hasText() {
      let slot = this.$slots.default
      if (slot && slot.length > 0) {
        return true
      }
      return false
    },
    buttonCls() {
      return {
        [`${prefix}`]: true,
        [`${prefix}-circle`]: !!this.circle || !!this.iconCircle,
        [`${prefix}-icon-circle`]: !!this.iconCircle,
        [`${prefix}-text`]: !!this.text,
        [`${prefix}-loading`]: !!this.loading,
        [`${prefix}-block`]: !!this.block,
        [`${prefix}-text-${this.textColor}`]: !!this.textColor,
        [`${prefix}-${this.color}`]: !!this.color,
        [`${prefix}-${this.size}`]: !!this.size,
        [`${prefix}-transparent`]: !!this.transparent,
        [`${prefix}-no-border`]: this.noBorder === true,
      }
    },
    iconCode() {
      return this.loading ? "h-icon-loading" : this.icon
    },
    iconCls() {
      const iconCode = this.loading ? "h-icon-loading" : this.icon
      return {
        [`${iconCode}`]: !!iconCode,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.h-btn {
    outline: none;
    padding: 8px 15px;
    font-family: inherit;
    display: inline-block;
    border-radius: 4px;
    color: inherit;
    font-size: 13px;
    line-height: 1;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .2s;
    background-color: rgba(0,0,0,0);
    border: 1px solid #d3d3d3;
    box-shadow: 0 1px 1px 0 #eee;
    background-color: #fff;
}

.h-btn.h-btn-blue {
    background-color: #0c5ee4;
    border-color: #0c5ee4;
    color: #fff;
}

.h-btn+.h-btn {
    margin-left: 4px;
}


.h-btn.h-btn-no-border {
    box-shadow: none;
    border-color: rgba(0,0,0,0);
}
.h-btn.h-btn-xs {
    padding: 2px 6px;
}
// .h-btn.h-btn-circle {
//     border-radius: 20px;
// }

.h-btn[disabled], .h-btn[disabled]:hover { 
    background: #D8D8D8;
    // border-color: #d3d3d3;
    color: #FFFFFF;
}

.h-btn[disabled] {
    cursor: not-allowed;
}
.h-btn.h-btn-gray {
    background-color: #c1c1c1;
    border-color: #bcbcbc;
    color: #fff;
}

.h-btn.h-btn-transparent {
    background: rgba(0,0,0,0);
        border-color: #0c5ee4;
    color: #0c5ee4;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ByButton2.vue